import { object, number, string, InferType } from "yup";
import { IRANIAN_PHONE_NUMBER_REGEX, passwordPattern } from "@/constants/regex";

const loginByPasswordSchema = object({
  mobile: number()
    .test("isValidPhoneNumber", (phone, ctx) => {
      return IRANIAN_PHONE_NUMBER_REGEX.test("0" + String(phone));
    })
    .required("فیلد اجباری است"),
  password: string()
    .min(8, "رمز عبور باید حداقل ۴ حرف باشد")
    .required("فیلد اجباری است"),
});

export { loginByPasswordSchema };

export type LoginByPasswordSchema = InferType<typeof loginByPasswordSchema>;
